import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../assets/kazhavda-logo.png";
import {
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "../../contexts/AuthContext";
import SponsoredSlot from "../Sponsored/SponsoredSlot";
import "./Login.css";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [groomName, setGroomName] = useState("");
  const [groomLastName, setGroomLastName] = useState("");
  const [brideName, setBrideName] = useState("");
  const [brideLastName, setBrideLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const { signup } = useAuth();
  const API = process.env.REACT_APP_API_BASE;

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");
    setFieldErrors({});

    if (password !== confirmPassword) {
      setError("Лозинката не се совпаѓа.");
      return;
    }

    try {
      const response = await fetch(`${API}/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          groom_name: groomName,
          groom_last_name: groomLastName,
          bride_name: brideName,
          bride_last_name: brideLastName,
          phone_number: phoneNumber,
        }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => null);
        if (errData?.errors) {
          setFieldErrors(errData.errors);
          throw new Error("Внесените податоци се невалидни.");
        } else {
          throw new Error(errData?.message || "Неуспешна регистрација.");
        }
      }

      const { email: user_email, firebase_uuid } = await response.json();

      signup({ user_email, firebase_uid: firebase_uuid });
      navigate("/login", { state: { fromSignup: true } });
    } catch (err) {
      console.error("Error during sign up:", err);
      setError(err.message);
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid
        item
        size={{ xs: 10, md: 8, lg: 6, xl: 4 }}
        className="form-container"
      >
        <form onSubmit={handleSignUp}>
          <Grid container direction="column" spacing={2}>
            <Grid item className="form-container-logo">
              <img src={logo} alt="Kazhav Da Logo" className="form-logo" />
            </Grid>
            <Grid item>
              <Typography variant="h5" className="form-title">
                Регистрација
              </Typography>
            </Grid>
            {error && (
              <Grid item>
                <Typography variant="body2" color="error">
                  {error}
                </Typography>
              </Grid>
            )}
            <Grid item>
              <TextField
                label="Е-мејл адреса"
                variant="outlined"
                fullWidth
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-text-field"
                required
                error={Boolean(fieldErrors.email)}
                helperText={fieldErrors.email}
              />
            </Grid>
            <Grid item>
              <TextField
                label="Лозинка"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-text-field"
                required
                error={Boolean(fieldErrors.password)}
                helperText={fieldErrors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item>
              <TextField
                label="Потврди лозинка"
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-text-field"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item size={6}>
                <TextField
                  label="Име на младоженец"
                  variant="outlined"
                  fullWidth
                  value={groomName}
                  onChange={(e) => setGroomName(e.target.value)}
                  className="form-text-field"
                  required
                  error={Boolean(fieldErrors.groom_name)}
                  helperText={fieldErrors.groom_name}
                />
              </Grid>

              <Grid item size={6}>
                <TextField
                  label="Презиме на младоженец"
                  variant="outlined"
                  fullWidth
                  value={groomLastName}
                  onChange={(e) => setGroomLastName(e.target.value)}
                  className="form-text-field"
                  required
                  error={Boolean(fieldErrors.groom_last_name)}
                  helperText={fieldErrors.groom_last_name}
                />
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item size={6}>
                <TextField
                  label="Име на невеста"
                  variant="outlined"
                  fullWidth
                  value={brideName}
                  onChange={(e) => setBrideName(e.target.value)}
                  className="form-text-field"
                  required
                  error={Boolean(fieldErrors.bride_name)}
                  helperText={fieldErrors.bride_name}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  label="Презиме на невеста"
                  variant="outlined"
                  fullWidth
                  value={brideLastName}
                  onChange={(e) => setBrideLastName(e.target.value)}
                  className="form-text-field"
                  required
                  error={Boolean(fieldErrors.bride_last_name)}
                  helperText={fieldErrors.bride_last_name}
                />
              </Grid>
            </Grid>
            <Grid item>
              <TextField
                label="Телефонски број"
                variant="outlined"
                fullWidth
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="form-text-field"
                required
                error={Boolean(fieldErrors.phone_number)}
                helperText={fieldErrors.phone_number}
              />
            </Grid>

            <Grid item>
              <Button
                type="submit"
                variant="contained"
                className="button-login"
                fullWidth
              >
                Регистрирај се
              </Button>
            </Grid>
            <Grid item>
              <Typography variant="body2" className="form-container-link">
                Веќе имате профил?{" "}
                <Link to="/login" className="custom-link">
                  Најавете се
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </form>
        <SponsoredSlot placement="signup.bottom" />
      </Grid>
    </Grid>
  );
}

export default SignUp;
